import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Dot.module.css';

export default function Dot({ color }) {
  return (
    <div
      className={cx(styles.dot, {
        [styles.redDot]: color === 'red',
        [styles.greenDot]: color === 'green',
      })}
      data-testid={`dot-${color}`}
    />
  );
}

Dot.propTypes = {
  color: PropTypes.string.isRequired,
};
